import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import LogoBankAccount from 'design-system/LogoBankAccount';
import RadioButton from 'design-system/RadioButton';
import BankConnectionStatus from './BankConnectionStatus';
import { isWeb } from '../../../../constants';
const BankConnectionRow = ({ data, showStatus = true, radioType, isSelected }) => (<View style={styles.container}>
    {!!radioType && <RadioButton type={radioType} isChecked={isSelected}/>}
    <LogoBankAccount size="R44" data={data.bankInfo} onCard/>
    <View style={styles.flex1}>
      <Text Text-16 numberOfLines={1}>
        {data.bankInfo.name}
      </Text>
      {!!showStatus && <BankConnectionStatus data={data}/>}
    </View>
  </View>);
const styles = StyleSheet.create({
    container: {
        padding: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(16),
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    flex1: {
        flex: 1,
    },
});
export default BankConnectionRow;
